import React from "react";
import { useSelector } from "react-redux";
import { Link, useLocation } from "react-router-dom";

const Footer = () => {
  const auth = useSelector((state) => state.auth);
  const location = useLocation();
  const page_location = location.pathname.split('/')[1];
  return (
    <>
      <footer id="footer-part">
        {/* {(!auth || page_location!="user") &&
          <div className="footer-top pt-40 pb-70">
            <div className="container">
              <div className="row">
                <div className="col-lg-3 col-md-6">
                  <div className="footer-about mt-40">
                    <div className="logo">
                    <Link to="/"><img src={process.env.PUBLIC_URL+"/images/cdri-logo.png"} alt="Logo" /></Link>
                    </div>
                    <p></p>
                    <ul className="mt-20">
                      <li><a href="https://www.facebook.com/Coalition-for-Disaster-Resilient-Infrastructure-109999954712859" target={"blank"}><i className="fa fa-facebook-f"></i></a></li>
                      <li><a href="https://twitter.com/cdri_world" target={"blank"}><i className="fa fa-twitter"></i></a></li>
                      <li><a href="https://www.linkedin.com/company/coalition-for-diasaster-resilient-infrastructure/" target={"blank"}><i className="fa fa-linkedin"></i></a></li>
                      <li><a href="https://www.youtube.com/channel/UCh44NgGlVNdx0rtwel9OFvA" target={"blank"}><i className="fa fa-youtube"></i></a></li>
                    </ul>
                  </div> 
                </div>
                <div className="col-lg-3 col-md-6 col-sm-6">
                  <div className="footer-link mt-40">
                    <div className="footer-title pb-25">
                      <h6>Sitemap</h6>
                    </div>
                    <ul>
                      <li><Link to={"/"}><i className="fa fa-angle-right"></i>Home</Link></li>
                      <li><Link to={"/fellowship-programme"}><i className="fa fa-angle-right"></i>CDRI Fellowship Programme</Link></li>
                      <li><Link to={"/scope"}><i className="fa fa-angle-right"></i>Scope</Link></li>
                      <li><Link to={"/salient-features"}><i className="fa fa-angle-right"></i>Salient Features</Link></li>
                      <li><Link to={"international-jury"}><i className="fa fa-angle-right"></i>International Jury</Link></li>
                    </ul>
                    <ul>
                    </ul>
                  </div> 
                </div>
                <div className="col-lg-3 col-md-6 col-sm-6">
                  <div className="footer-link support mt-40">
                    <div className="footer-title pb-25">
                      <h6>Support</h6>
                    </div>
                    <ul>
                      <li><Link to={"/important-dates"}><i className="fa fa-angle-right"></i>Important Dates</Link></li>
                      <li><Link to={"selection-process"}><i className="fa fa-angle-right"></i>Selection Process</Link></li>
                      <li><Link to={"instructions"}><i className="fa fa-angle-right"></i>Instructions</Link></li> 
                      <li><Link to={"faqs"}><i className="fa fa-angle-right"></i>FAQS</Link></li>
                      <li><Link to={"privacy-notice"}><i className="fa fa-angle-right"></i>Privacy Notice</Link></li>
                      <li><Link to={"terms-of-use"}><i className="fa fa-angle-right"></i>Terms Of Use</Link></li>
                      <li><a href="https://www.cdri.world/privacy-notice" target={"blank"}><i className="fa fa-angle-right"></i>Privacy Notice</a></li>
                      <li><a href="https://www.cdri.world/terms-of-use" target={"blank"}><i className="fa fa-angle-right"></i>Terms Of Use</a></li>
                    </ul>
                  </div>
                </div>
                <div className="col-lg-3 col-md-6">
                  <div className="footer-address mt-40">
                    <div className="footer-title pb-25">
                      <h6>Contact Us</h6>
                    </div>
                    <ul>
                      <li>
                        <div className="icon">
                          <i className="fa fa-envelope-o"></i>
                        </div>
                        <div className="cont">
                          <p>fellowship@cdri.world</p>
                        </div>
                      </li>
                      <li>
                        <div className="icon">
                          <i className="fa fa-phone"></i>
                        </div>
                        <div className="cont">
                          <p>+91-11-4044-5999</p>
                        </div>
                      </li>
                      <li>
                        <div className="icon">
                          <i className="fa fa-home"></i>
                        </div>
                        <div className="cont">
                          <p>4th 5th Floor, Bharatiya Kala Kendra, 1, Copernicus Marg, New Delhi, 110001, INDIA</p>
                        </div>
                      </li>
                    </ul>
                  </div>
                </div>
              </div> 
            </div> 
          </div> 
        } */}
        <div className="footer-copyright pt-10 pb-25">
          <div className="container">
            <div className="row">
              <div className="col-md-8">
                <div className="copyright text-md-left text-center pt-15">
                  {/* {(auth && page_location=="user") && */}
                  <div className="row">
                    <div className="col-md-6">
                      <p>For queries, please contact: <a href="mailto:fellowship@cdri.world">fellowship@cdri.world</a></p>
                    </div>
                    <div className="col-md-6 text-center">
                      <div className="header-social text-center">
                        <ul>
                          <li><a href="https://www.facebook.com/Coalition-for-Disaster-Resilient-Infrastructure-109999954712859" target={"blank"}><i className="fa fa-facebook-f"></i></a></li>
                          <li><a href="https://twitter.com/cdri_world"><i className="fa fa-twitter" target={"blank"}></i></a></li>
                          <li><a href="https://www.linkedin.com/company/coalition-for-diasaster-resilient-infrastructure/" target={"blank"}><i className="fa fa-linkedin"></i></a></li>
                          <li><a href="https://www.youtube.com/channel/UCh44NgGlVNdx0rtwel9OFvA" target={"blank"}><i className="fa fa-youtube"></i></a></li>
                        </ul>
                      </div>
                    </div>
                  </div>
                  {/* } */}
                </div>
              </div>
              <div className="col-md-4">
                <div className="copyright text-md-csnter text-center text-md-right pt-15">
                  <p>©All Rights Reserved by <a href="https://cdri.world" target={"blank"} className="refc">CDRI</a></p>
                </div>
              </div>
            </div> {/* row */}
          </div> {/* container */}
        </div> {/* footer copyright */}
      </footer>
    </>
  );
};

export default Footer;